import React from 'react';
import Help from '@material-ui/icons/Help';
import styles from './index.css';

export default function HelpIcon(props) {
  return (
    <Help {...props} className={styles.component} />
  );
}
